export const ALL_EXAM_DROP_JSON = [
  { id: 0, value: 'All' },
  { id: 1, value: 'Exam 1' },
  { id: 2, value: 'Exam 2' },
  { id: 3, value: 'Exam 3' },
  { id: 4, value: 'Exam 4' },
  { id: 5, value: 'Exam 5' },
  { id: 6, value: 'Exam 6' },
  { id: 7, value: 'Exam 7' },
  { id: 8, value: 'Exam 8' },
];
